<template>
  
  <div>
    <!-- 登录前轮播页 -->
    <div class="box_two custom-carousel" v-if="showjz" @click="tiguo">
      <el-carousel ref="carousel" trigger="click" style="width: 100%;height: 100vh;position: absolute;" arrow="never" :autoplay="false">
        <el-carousel-item v-for="(item,index) in lgqimg" :key="index" style="width: 100%;height: 100vh;">
            <img style="width: 100%;height: 100%;" :src="item.img" alt="Carousel Image" class="fade-item">
        </el-carousel-item>
      </el-carousel>
      <el-button style="font-size: 16px;position: absolute;top: 20px;right: 20px;z-index: 99999;" round>跳过</el-button>
    </div>
    <!-- 登录输入框 -->
    <div class="box_one" v-if="!showjz">
        <div class="box_zfg"></div>
        <div class="box_fgz">
          <div class="box_onea">
            <!-- <div style="font-size: 20px;font-weight: bold;" @click="onttab(itab)">{{appName}}</div> -->
            <div class="box_onea_p1">
              <!-- <div :class="itab == index?'box_onea_p1b':'box_onea_p1a'" v-for="(val,index) in tablist" :key="index" @click="ontab(index)">{{ val.title }}</div> -->
              <div class="box_onea_p1a" @click="ontab(0)" :class="itab == 0?'box_onea_p1d':'box_onea_p1c'">微信登录</div>
              <div class="box_onea_p1b" @click="ontab(1)" :class="itab == 1?'box_onea_p1d':'box_onea_p1c'">账号登录</div>
            </div>
            <div style="padding: 0px 50px;height: 312px;margin-top: 30px;">
              <el-form ref="loginForm" v-if="itab == 1" :model="loginForm" :rules="fieldRules" label-position="left" label-width="0px" style="">
                <div style="font-size: 22px;text-align: left;color:#000;">登录</div>
                <div style="text-align: left;font-size: 12px;color: #999;margin-top: 30px;">请输入账号</div>
                <div style="display: flex;align-items: center;width: 100%;border-bottom: 1px solid #E8E8E8;">
                    <el-input ref="account" v-model="loginForm.account" type="text" @keyup.native="accountEnter($event)" @blur.prevent="getCaptcha"></el-input>
                    <i class="el-icon-user" style="color: #999;"></i>
                </div>
                <div style="text-align: left;font-size: 12px;color: #999;margin-top: 20px;">请输入密码</div>
                <div style="display: flex;align-items: center;width: 100%;border-bottom: 1px solid #E8E8E8;">
                    <el-input ref="password" v-model="loginForm.password" type="password" :show-password="true" @keyup.enter.native="login" @blur.prevent="getCaptcha"></el-input>
                    <i class="el-icon-lock" style="color: #999;"></i>
                </div>
                <!-- <el-input ref="account" v-model="loginForm.account" type="text" placeholder="输入账号" prefix-icon="el-icon-user" @keyup.native="accountEnter($event)" @blur.prevent="getCaptcha"></el-input> -->
                <!-- <el-input style="margin-top: 8px;" ref="password" v-model="loginForm.password" type="password" placeholder="输入密码" :show-password="true" prefix-icon="el-icon-lock" @keyup.enter.native="login" @blur.prevent="getCaptcha"></el-input> -->
                <div style="width: 100%;display: flex;align-items: center;">
                  <el-popover placement="top-start" width="220" trigger="click" style="visibility: hidden;">
                    <img style="width:220px;" src="../../static/img/installqrcode.png" mode="widthFix"/>
                    <i class="el-icon-mobile-phone" slot="reference" style="font-size: 12px;color: #2662D3;">app下载</i>
                  </el-popover>
                  <div style="height: 30px;line-height: 30px;flex: 1;text-align: right;margin-top: 20px;">
                    <span style="font-size: 12px;color: #00A29D;" @click="onreset()">重置登录</span>
                  </div>
                </div>
                <el-button style="width: 100%;margin-top: 30px;background-color: #00A29D;color: #fff;border-radius: 10px;font-size: 16px;" :loading="loading" @click.native.prevent="login">{{openId == ''?'立即登录':'立即绑定'}}</el-button>
              </el-form>
              <div v-if="itab == 0" style="width: 300px;padding-top: 20px;">
                <div style="width: 220px;margin-left: 40px;">
                  <div style="width: 220px;height: 220px;position: absolute;">
                    <img style="width: 100%;height: 100%;" :src="wechatSrc" mode="aspectFit"/>
                  </div>
                  <div :style="wechatTimelimit?'':'visibility: hidden;'" style="width: 220px;height: 220px;display: flex;align-items: center;justify-content: center;position: relative;z-index: 990;transition: all 0.5s; background:rgba(0,0,0,0.6);">
                    <el-button icon="el-icon-refresh-left" @click="openWechat" :loading="wechatload" plain>刷新二维码</el-button>
                  </div>
                </div>
                <div style="height: 30px;line-height: 30px;font-size: 16px;color: #C1C1C1;margin-top: 30px;">请用微信扫一扫上方二维码登录</div>
              </div>
            </div>
            <div class="app01">
              <img src="../../static/img/newapp10.png" mode="aspectFit" @click="dialogTableVisible = true"/>
            </div>
          </div>
        </div>
    </div>
    <el-form ref="loginForm"
             :model="loginForm"
             :rules="fieldRules"
             label-position="left"
             label-width="0px"
             class="demo-ruleForm login-container" style="display: none;"
    >
      <div v-show="!showRegist">
        <span class="tool-bar">
          <!-- 主题切换 -->
          <theme-picker style="float:right;"
                        class="theme-picker"
                        :default="themeColor"
                        @onThemeChange="onThemeChange"
          />
          <!-- 语言切换 -->
          <!-- <lang-selector class="lang-selector"></lang-selector>    -->
        </span>
        <h2 class="title"
            style="padding-left:22px;"
        >
          {{ appName }}
        </h2>
        <!-- <div style="display:flex;justify-content: flex-end">
          <el-button type="text"
                     @click="openFace"
          >
            人脸登录
          </el-button>
        </div> -->
        <div style="display:flex;justify-content: flex-end">
          <el-button type="text"
                     @click="openWechat"
                     :loading="wechatload"
          >
            微信登录
          </el-button>
        </div>
        <el-form-item prop="account">
          <el-input ref="account"
                    v-model="loginForm.account"
                    type="text"
                    auto-complete="off"
                    placeholder="账号"
                    @keyup.native="accountEnter($event)"
                    @blur.prevent="getCaptcha"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input ref="password"
                    v-model="loginForm.password"
                    type="password"
                    auto-complete="off"
                    placeholder="密码"
                    @keyup.enter.native="login"
          />
        </el-form-item>
        <el-form-item v-if="loginForm.src">
          <el-col :span="12">
            <el-form-item prop="captcha">
              <el-input v-model="loginForm.captcha"
                        type="test"
                        auto-complete="off"
                        placeholder="验证码, 单击图片刷新"
                        style="width: 100%;"
                        @keyup.enter.native="login"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col class="line"
                  :span="1"
          >
&nbsp;
          </el-col>
          <el-col :span="11">
            <el-form-item>
              <img style="width: 100%;"
                   class="pointer"
                   :src="loginForm.src"
                   @click="getCaptcha"
              >
            </el-form-item>
          </el-col>
        </el-form-item>
        <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
        <!-- <el-form-item>
          <div style="text-align: left;">
            还没有账号？
            <a style="color:#009999; text-decoration: underline;"
               href="#/pwdRegister"
               @click="toDesign"
            >马上注册？</a>
          </div>
        </el-form-item> -->
        <el-form-item style="width:100%;">
          <el-button type="primary"
                     style="width:45%;"
                     @click.native.prevent="reset"
          >
            重 置
          </el-button>
          <el-button type="primary"
                     style="width:45%;"
                     :loading="loading"
                     @click.native.prevent="login"
          >
            {{openId == ''?'登 录':'立即绑定'}}
          </el-button>
        </el-form-item>
        <el-dialog v-dialogDrag
                   width="500px"
                   :visible.sync="dialogVisibleface"
                   :before-close="close"
                   :show-close="false"
                   @open="facekey = true"
        >
          <WebRTCFaceRecognition v-if="facekey"
                                 ref="WebRTCFaceRecognition"
                                 @update="submit"
          ></WebRTCFaceRecognition>
        </el-dialog>
        <el-dialog v-dialog-drag
                   width="60%"
                   :visible.sync="dialogVisibleHelp"
        >
          <img v-if="jtimg"
               style="width:914px;margin-top:50px"
               src="../../static/img/help.png"
               alt=""
          >
          <img v-else
               style="width:914px;margin-top:50px"
               src="../../static/img/help.gif"
               alt=""
          >
          <span slot="footer"
                class="dialog-footer"
          >
            <el-button @click="jtimg = true">取消动画</el-button>
            <el-button type="primary"
                       @click="jtimg = false"
            >查看动画</el-button>
          </span>
        </el-dialog>
      </div>
      <PasswordRegistration v-if="showRegist"
                            :close-event="registClose"
      ></PasswordRegistration>
    </el-form>
    <div class="netPointNo" v-if="!showjz"
         @click="netPointNo"
    >
      COPYRIGHT © 2021 版权所有：深圳市维旺迪电子有限公司 粤ICP备2021092089号-1
    </div>
    <!-- <div class="box_install">
        <div class="box_installa" @click="dialogTableVisible = true">
          <img src="../../static/img/app_install.png"/>
        </div>
    </div> -->
    <el-dialog title="" width="25%" :visible.sync="dialogTableVisible">
        <img style="width:100%" src="../../static/img/installqrcode.png" mode="widthFix"/>
    </el-dialog>
    <!-- 微信登录二维码显示 -->
    <el-dialog title="" width="330px" :visible.sync="wechatVisible" :close-on-click-modal="false" @close="closeWchat" style="display: none;">
        <div style="width: 260px;margin-left: 15px;">
          <div style="width: 260px;height: 260px;position: absolute;">
            <img style="width: 100%;height: 100%;" :src="wechatSrc" mode="aspectFit"/>
          </div>
          <div :style="wechatTimelimit?'':'visibility: hidden;'" style="width: 260px;height: 260px;display: flex;align-items: center;justify-content: center;position: relative;z-index: 990;transition: all 0.5s; background:rgba(0,0,0,0.6);">
            <el-button icon="el-icon-refresh-left" @click="openWechat" :loading="wechatload" plain>刷新二维码</el-button>
          </div>
        </div>
        <div>请用微信扫一扫上方二维码登录</div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import ThemePicker from "@/components/ThemePicker";
import WebRTCFaceRecognition from "@/components/faceapi/WebRTCFaceRecognition";
import PasswordRegistration from "@/views/PasswordRegistration";
export default {
  inject:['canvasInfo','removeWatermark'],
  name: "Login",
  components: {
    ThemePicker,
    WebRTCFaceRecognition,
    PasswordRegistration
  },
  data() {
    return {
      dialogTableVisible:false,
      showRegist: false,
      jtimg: true,
      dialogVisibleHelp: false,
      facekey: false,
      dialogVisibleface: false,
      lastTimeStamp: 0, // 标记当前事件函数的时间戳
      loading: false,
      loginForm: {
        account: "",
        password: "",
        captcha: "",
        src: ""
      },
      fieldRules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      // 登录框
      tablist:[
        {
          title:'微信登录',
          num:0
        },
        {
          title:'账号登录',
          num:1
        }
      ],
      itab:0,//当前默认点击按钮
      checked: true,
      wechatload:false,//微信登录按钮状态
      wechatTime:'',//循环定时器
      wechatVisible:false,//二维码弹窗
      wechatSrc:'',//微信二维码
      wechatTimelimit:false,//二维码是否已过期
      openId:'',//微信登录openId
      wechataling:false,//是否不需要获取二维码
      lgqimg:[
        {img:'../../static/img/wh/wh1.png'},
        {img:'../../static/img/wh/wh2.png'},
        {img:'../../static/img/wh/wh3.png'},
        {img:'../../static/img/wh/wh4.png'},
        {img:'../../static/img/wh/wh5.png'},
        {img:'../../static/img/wh/wh6.png'},
        {img:'../../static/img/wh/wh7.png'}
      ],
      showjz:false,//登录成功显示价值观轮播
      tgodata:'',
      timeout115:'',//价值观定时器
    };
  },
  computed: {
    ...mapState({
      appName: state => state.app.appName,
      themeColor: state => state.app.themeColor
    })
  },
  provide() {
    return {
      close: this.close
    };
  },
  mounted() {
    // this.refreshCaptcha()
    this.$refs.account.focus();
    this.openWechat()
    this.startCarousel();
  },

  methods: {
    startCarousel() {
      setInterval(() => {
        if(this.$refs.carousel) this.$refs.carousel.next();
      }, 3200);
    },
    // 跳转到注册
    toDesign() {
      this.showRegist = true;
    },
    // 注册返回
    registClose() {
      this.showRegist = false;
    },
     /**
     *conc：2023/03/07
     *描述：微信登录
     */
     onttab(i){
      if(i == 1){
        this.itab = 0;
      }else{
        this.itab = 1;
      }
      this.ontab(this.itab)
     },
    //切换登录方式
    ontab(i){
      this.itab = i;
      if(i == 0){
        //二维码过期，需要获取二维码
        //是否不需要获取二维码为否时就是第一次点击，这时候需要获取二维码
        if(this.wechatTimelimit || !this.wechataling || this.openId != ''){
          this.openWechat()
        }
      }else{
        //切换回账号密码，表示已经获取过二维码，不需要获取二维码
        this.wechataling = true;
        this.closeWchat()
      }
    },
    openWechat(){
      this.wechatload = true;
      let sceneStr = this.suiabbre();
      // console.log('openWechat----sceneStr',sceneStr);
      this.axios({
        url: this.zuul + "/xyj-admin/wx/login/pcQrCode",
        method: "get",
        params: {
          sceneStr: sceneStr
        }
      }).then(res => {
        if (res) {
          this.wechatSrc = res.data.qrCodeUrl;
          // this.wechatVisible = true;
          this.wechatTimelimit = false;
          this.wechatload = false;
          //设置缓存
          this.setItem(res.data.sceneStr)
        }
      }).catch(err => {
        this.$message.error(err.message);
        this.wechatload = false;
      });
    },
    //通过sceneStr获取登录信息undefined
    getSceneStr(){
      const sceneStr = this.getItem('sceneStr');
      // console.log('getSceneStr----sceneStr',sceneStr)
      if(sceneStr == 'undefined' || sceneStr == '' || sceneStr == null){
        return;
      }
      this.axios({
        url: this.zuul + "/xyj-admin/wx/login/getSceneStr",
        method: "get",
        params: {
          sceneStr: sceneStr
        }
      }).then(res => {
        if (res.data != null) {
          // console.log('res登录信息====',res);
          //清除定时器
          clearInterval(this.wechatTime);
          //删除缓存
          sessionStorage.removeItem('sceneStr');
          this.wechatVisible = false;
          this.wechatload = false;
          //type 0=未绑定账号  1=登录成功  2=禁用
          if(res.data.type == '0'){
            this.$message.success('请输入账号密码绑定微信');
            this.itab = 1;
            this.openId = res.data.data
          }else if(res.data.type == '1'){
            this.$message.success('微信扫码成功');
            // this.tgodata = res.data;
            // this.showjz = true;
            // this.timeout115 = setTimeout(() => {
            //   this.showjz = false;
            //   this.successLogin(res.data);
            // }, 20115);
            this.successLogin(res.data);
          }else if(res.data.type == '2'){
            this.$message.info('账号被禁用,请联系管理员');
          }
        }
      }).catch(err => {
        this.$message.error(err.message);
      });
    },
    //设置缓存 sceneStr 缓存内容
    setItem(sceneStr){
      //设置缓存过期时间,缓存过期则二维码
      const obj = {
        value:sceneStr,//缓存值
        expire:300,//过期时间，默认60秒
        timestamp:new Date().getTime()//当前时间
      }
      const stringfiedData = JSON.stringify(obj);
      sessionStorage.setItem('sceneStr',stringfiedData);
      //循环获取登录信息，获取到则表示登录成功
      this.wechatTime = setInterval(() => {
        this.getSceneStr();
      },1000)
    },
    //获取缓存 key 保存数据的key
    getItem(key){
      const storeData = sessionStorage.getItem(key);
      const parsedData = JSON.parse(storeData);
      var timestamp = parsedData.timestamp || 0
      const currentTimestamp = new Date().getTime();
      //判断缓存是否超时
      if (currentTimestamp - timestamp <= parsedData.expire * 1000) {
        return parsedData.value;
      } else {
        //超时清除定时器，需要重新获取二维码
        clearInterval(this.wechatTime);
        //超时删除缓存
        sessionStorage.removeItem(key);
        this.$message.info('二维码已过期，请刷新');
        this.wechatTimelimit = true;
        this.openId = '';
      }
    },
    // 随机生成唯一key,当前时间戳加6个随机字母组成
	  suiabbre() {
      //获取当前时间戳
      var timestamp=new Date().getTime();
		  // 随机生成6位数字母
		  var arr = []; // 空的数组，用于保存字母
		  for (var i = 65;i <= 90;i++) { // 根据Unicode码转译大写字母 小写字母是97-122
		  	arr.push(String.fromCharCode(i));
		  }
		  var arr2 = ""; // 保存输出的字符
		  for (var i = 0;i < 6;i++) {
		      var index = Math.floor(Math.random() * arr.length);
		      arr2 = arr2 + arr[index];
		      // 把取到的随机元素在原数组中删除
		      arr.splice(index, 1);
		  }
      let sceneStr = timestamp + arr2;
      return sceneStr
	  },
    //关闭二维码弹窗
    closeWchat(){
      this.wechatload = false;
    },

    openFace() {
      this.dialogVisibleface = true;
      if (!navigator.mediaDevices) {
        this.dialogVisibleHelp = true;
      }
    },
    // 人脸采集
    submit(src) {
      sessionStorage.setItem("tkn", "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ");
      Cookies.set("token", "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ");
      this.axios({
        url: this.zuul + "/xyj-aiauto/w/sysUserFace/compareFaceBASE64/0",
        method: "post",
        params: {
          fileBase64: src
        }
      }).then(res => {
        this.facelogin(res.data.faceurl, res.data.regId, res.data.regtype);
      }).catch(err => {
        this.facekey = false;
        this.$message.error(err.message);
        setTimeout(() => {
          this.facekey = true;
        }, 200);
      });
    },
    // 业务库登录
    facelogin(url, id, memo) {
      this.axios({
        url: this.zuul + "/xyj-admin/r/facelogin",
        method: "post",
        params: {
          faceurl: url,
          id: id,
          type: memo
        }
      }).then(res => {
        Cookies.remove("token");
        sessionStorage.removeItem("tkn");
        if (res.data.token.token) {
          // 放置token到Cookie
          Cookies.set("token", res.data.token.token);
          sessionStorage.setItem("tkn", res.data.token.token);
        } else {
          Cookies.set("token", res.data.token); // 放置token到Cookie
          sessionStorage.setItem("tkn", res.data.token);
        }
        sessionStorage.setItem("userid", res.data.loginInfo.userid);
        sessionStorage.setItem("user", res.data.loginInfo.username); // 保存用户到本地会话
        sessionStorage.setItem("createTime", res.data.loginInfo.user.createTime); // 保存用户注册时间到本地会话
        sessionStorage.setItem("chatid", res.data.chatid); // 保存聊天ID到本地会话
        sessionStorage.setItem("branchCode", res.data.branchCode); // 保存branchCode到本地会话
        sessionStorage.setItem("branchId", res.data.branchId); // 保存branchCode到本地会话

        setTimeout(() => {
          // 用于订阅mqtt消息判断
          this.$addStorageEvent(2, "userid", res.data.loginInfo.userid);
        }, 800);
        // sessionStorage.removeItem('branchCode')
        this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
        this.getControl();
        this.$router.push("/");  // 登录成功，跳转到主页
      }).catch(err => {
        this.$message.error(err.message);
      });
    },
    close() {
      // 关闭摄像头
      if (navigator.mediaDevices) {
        this.$refs.WebRTCFaceRecognition.fnClose();
      }
      this.facekey = false;
      this.dialogVisibleface = false;
    },
   
    accountEnter(event) {
      /* if(event.keyCode != 13){//除回车键外
          //标记当前事件函数的时间戳
          this.lastTimeStamp = event.timeStamp;
          setTimeout(() => {
              //1s后比较二者是否还相同（因为只要还有事件触发，lastTimeStamp就会被改写，不再是当前事件函数的时间戳）
              if(this.lastTimeStamp == event.timeStamp){
                if(this.loginForm.account){
                  this.getCaptcha()
                }
              }
          }, 1000);
      }*/
      if (event.keyCode == 13 && this.loginForm.account.length > 0) {
        this.$refs.password.focus();
      }
    },
    // 获取验证码
    getCaptcha() {
      this.axios({
        url: this.zuul + "/xyj-admin/w/getPcCaptcha",
        method: "get",
        params: {
          userName: this.loginForm.account
        }
      }).then(res => {
        if (res) {
          this.loginForm.src = res.msg;
        }
      }).catch(err => {
        this.$message.error(err.message);
      });
    },
    // 聊天是否展示请求判断
    getControl() {
      this.jquery.ajax({
        headers: { "token": sessionStorage.getItem("tkn"), "Content-Type": "application/json;charset=UTF-8" },
        url: this.zuul + "/xyj-admin/r/sysProject/chatStat",
        type: "get",
        async: false,
        processData: false,
        success: function(data) {
          sessionStorage.setItem("chat_funciton", data.msg);
        }
      });
    },
    login() {
      const _this = this;
      //2023-09-06 判断密码，太简单的密码要提醒修改密码 
      if(this.loginForm.password == '0123456' || this.loginForm.password == '123456' || this.loginForm.password == '012345678' || this.loginForm.password == '666666' || this.loginForm.password == '654321' || this.loginForm.password == '888888' || this.loginForm.password == '000000' || this.loginForm.password == '111111' || this.loginForm.password == '12345678'){
        sessionStorage.setItem('jypsw',this.loginForm.password)
      }
      this.loading = true;
      const userInfo = {
        account: this.loginForm.account,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha,
        usertype: 0,
        suffix: this.suffix ? Number(Math.random() * 10000000000000 + Date.now()).toString().substr(0, 4) : "",
        openId: this.openId
      };
      this.axios({
        url: this.zuul + "/xyj-admin/r/login",
        method: "post",
        data: userInfo
      }).then(res => {
        // this.tgodata = res;
        // this.showjz = true;
        // this.timeout115 = setTimeout(() => {
        //   this.showjz = false;
        //   this.successLogin(res);
        // }, 20115);
        this.successLogin(res);
        //清除定时器，需要重新获取二维码
        clearInterval(this.wechatTime);
        //删除缓存
        sessionStorage.removeItem('sceneStr');
      }).catch(err => {
        this.getCaptcha();
        this.$message.error(err.message);
        this.loading = false;
      });
    },
    tiguo(){
      if(this.tgodata != ''){
        clearTimeout(this.timeout115)
        this.successLogin(this.tgodata);
      }
    },
    //登录成功后执行
    successLogin(res){
      if (res.data.token.token) {
        // 放置token到Cookie
        // Cookies.set("token", res.data.token.token);
        sessionStorage.setItem("tkn", res.data.token.token);
      } else {
        // Cookies.set("token", res.data.token); // 放置token到Cookie
        sessionStorage.setItem("tkn", res.data.token);
      }
      sessionStorage.setItem("userid", res.data.loginInfo.userid);
      sessionStorage.setItem("user", res.data.loginInfo.username); // 保存用户到本地会话
      sessionStorage.setItem("createTime", res.data.loginInfo.user.createTime); // 保存用户注册时间到本地会话
      sessionStorage.setItem("chatid", res.data.chatid); // 保存聊天ID到本地会话
      sessionStorage.setItem("branchCode", res.data.branchCode); // 保存branchCode到本地会话
      sessionStorage.setItem("branchId", res.data.branchId); // 保存branchCode到本地会话
      sessionStorage.setItem("deptName", res.data.loginInfo.user.deptName); // 保存用户所属部门到本地会话 CZC
      sessionStorage.setItem("realName", res.data.loginInfo.empname); // 保存用户真实姓名 CZC
      sessionStorage.setItem("deptId", res.data.loginInfo.user.deptId); // 保存用户真实姓名 CZC
      sessionStorage.setItem("ip", res.data.ip);
      sessionStorage.setItem("ipAddress", res.data.ipAddress);
      sessionStorage.setItem("mobile", res.data.loginInfo.mobile);
      sessionStorage.setItem(
        "userInfo",
        JSON.stringify({
          userId: res.data.loginInfo.userid,
          chatid: res.data.chatid,
          userName: res.data.loginInfo.username,
          empname: res.data.loginInfo.empname,
          token: res.data.token.token,
          branchId: res.data.branchId,
          branchCode: res.data.branchCode,
          empLogo: res.data.headlogo
        })
      );
      sessionStorage.setItem('concRate',JSON.stringify(res.data.exchangeRate))
      setTimeout(() => {
        this.$addStorageEvent(2, "userid", res.data.loginInfo.userid);
      }, 800);
      // sessionStorage.removeItem('branchCode')
      this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
      this.getControl();
      // this.removeWatermark();//去除原来的水印 2024-01-22
      // this.canvasInfo();//水印 2024-01-22
      this.loading = false;
      setTimeout(() => {
        this.$router.push("/");  // 登录成功，跳转到主页  2023-08-15 此处增加显示登录前的轮播图 
      }, 200);
      
    },
    netPointNo() {
      window.open("https://beian.miit.gov.cn/");
    },
    refreshCaptcha() {
      this.loginForm.src = this.zuul + "/xyj-admin/r/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.openId = '';
      this.$refs.loginForm.resetFields();
    },
    //重置登录
    onreset(){
      this.loginForm.account = '';
      this.loginForm.password = '';
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit("setThemeColor", themeColor);
    },
    
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100vh;
  background: url(../../static/img/newbg08.png) no-repeat 100% 100%/cover;
  border-top: 1px solid #072565;
  box-sizing: border-box;
  padding-top: 5%;
}
.box_install{
  width: 60px;
  min-height: 60px;
  position: fixed;
  right: 20px;
  bottom: 100px;
  .box_installa{
    height: 60px;
    width: 60px;
    background-color: #072565;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .box_installa img{
    height: 30px;
    width: 30px;
  }
}
.box_installscan{
  height: 200px;
  width: 200px;
}
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      // margin: 0px auto 30px auto;
      margin: 0px auto 15px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
  .login-container /deep/ .el-dialog__header,.login-container /deep/ .el-dialog__body{
    padding:0;
    margin: 0;
  }
  .netPointNo {
    position: fixed;
    bottom: 25px;
    width: 100%;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }
  .box_one{
    width: 100%;
    height: 100vh;
    background: url(../../static/img/newbg08.png) no-repeat 100% 100%/cover;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .box_zfg{
    height: 104px;
    width: 585px;
    background: url(../../static/img/newbg09.png) no-repeat 100% 100%/cover;
    position: absolute;
    left: 5%;
    top:30px;
  }
  .box_fgz{
    position: absolute;
    right: calc(10% - 10px);
    top:calc(10% + 30px);
  }
  .box_oneb{
    font-size: 32px;
    color: #00A29D;
    width: 400px;
    padding-left: 50px;
    text-align: left;
    font-weight: 500;
  }
  .box_onea{
    margin-top: 20px;
    background-color: #fff;
    border-radius: 15px;
    width: 400px;
    height: 472px;
    box-shadow: 3px 3px 10px #DFD6CF;
  }
  .app01{
    width: 400px;
    text-align: right;
    margin-top: 22.5px;

    // background-color: #505458;
  }
  .app01 img{
    height: 50px;
    width: 50px;
  }
  .box_onea_p1{
    height: 58px;
    width: 100%;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .box_onea_p1a{
    width: 200px;
    height: 58px;
    line-height: 58px;
    text-align: left;
    padding-left: 50px;
  }
  .box_onea_p1b{
    width: 200px;
    height: 58px;
    line-height: 58px;
    text-align: right;
    padding-right: 50px;
  }
  .box_onea_p1c{
    color: #C1C1C1;
  }
  .box_onea_p1d{
    color: #333;
    border-bottom: 1px solid #00A29D;
  }
  .box_two{
    width: 100%;
    height: 100vh;
  }
  // .el-carousel__item h3 {
  //   color: #475669;
  //   font-size: 14px;
  //   opacity: 0.75;
  //   line-height: 150px;
  //   margin: 0;
  // }

  // .el-carousel__item:nth-child(2n) {
  //    background-color: #99a9bf;
  // }
  
  // .el-carousel__item:nth-child(2n+1) {
  //    background-color: #d3dce6;
  // }
</style>
<style>
  .box_onea .el-input__inner{
    border: none !important;
    padding: 0px 15px 0px 0px !important;
  }
  /* .custom-carousel {
    pointer-events: none;
  }

  .custom-carousel:hover {
    pointer-events: auto; 
  } */
  .custom-carousel .fade-item {
    opacity: 0.9;
    transition: opacity 0.5s ease;
  }

  .custom-carousel .fade-item.active {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue